import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./auth/login/login.component";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";
import { PageNotFoundComponent } from "./auth/page-not-found/page-not-found.component";
import { AuthGuard } from "./auth/guard/auth.guard";
import { GuestGuard } from "./auth/guard/guest.guard";
import { PrivacyPolicyComponent } from "./auth/privacy-policy/privacy-policy.component";
import { UnsavedChangesGuard } from "./guards/UnsavedChangesGuard";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("../app/pages/pages.module").then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [GuestGuard],
  },
  { 
    path: "register",
    loadChildren: () =>
      import("../app/auth/registration/registration.module").then(
        (m) => m.RegistrationModule
      ),
    canActivate: [GuestGuard],
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
    canActivate: [GuestGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canActivate: [GuestGuard],
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
    canActivate: []
  },
  {
    path: "frequently-asked-questions",
    loadChildren: () =>
      import("../app/auth/faq/faq.module").then(
        (m) => m.FaqModule
      ),
    canActivate: [],
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
